<template>
    <div ref="quizBox" class="quiz-box">
        <div v-if="currentLayer === 'rank'" class="rank-layer layer">
            <div class="title-bar">
                <led-timer v-if="timerRequired" :time-in-seconds="timeInSeconds" type="countdown" />
                <div class="title">{{ title }}</div>
                <div class="stat-info">
                    <span class="label">已提交</span>
                    <span class="data">{{ results.length }}</span>
                    <span class="quiz-member-count">/{{ memberCount }}</span>
                </div>
            </div>
            
            <div class="content-box">
                <div class="rank-box">
                    <table class="rank">
                        <thead>
                            <tr>
                                <th style="width: 15.0%;">排名</th>
                                <th style="width: 05.5%; text-align: right;"></th>
                                <th style="width: 28.0%; text-align: left;">姓名</th>
                                <th style="width: 21.5%">学号</th>
                                <th style="width: 10.0%;">得分</th>
                                <th style="width: 20.0%;">用时</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r in results" :key="r.user.id" :class="{'top-rank': r.rank <= 3, 'rank1': r.rank == 1, 'rank2': r.rank == 2, 'rank3': r.rank == 3}">
                                <td><div>{{ r.rank > 3 ? r.rank : '' }}</div></td>
                                <td><div class="avatar"><img :src="r.user.avatarUrl" alt="" class="avatar"></div></td>
                                <td><div>{{ r.user.fullName }}</div></td> 
                                <td><div>{{ r.user.studentNo }}</div></td>
                                <td><div>{{ r.score }}</div></td>
                                <td><div>{{ formatDuration(r.duration) }}</div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- 查看题目 -->
        <div v-if="currentLayer === 'topic'" class="topic-layer layer">
            <div class="title-bar">
                <div class="title">{{ title }}{{titlePlus}}</div>
            </div>
            <div class="content-box" @click.capture="onRichContentClick">
                <div class="topic-box" :class="{'moso-latex': currentTopic.latexIncluded}">
                    <div class="topic-meta">
                        <div class="topic-flag" :class="currentTopic.type">{{ getTopicTypeString(currentTopic.type) }}题</div><div class="gap"></div>
                        <div class="topic-score">{{ currentTopic.type == TYPE.FILL && currentTopic.fill && currentTopic.fill.blankAlternatives && currentTopic.fill.blankAlternatives.length ? currentTopic.fill.blankAlternatives.length * currentTopic.score : currentTopic.score }} 分</div>
                        <div class="gap"></div>
                        <div class="topic-level">{{ parseLevel(currentTopic.level) }}</div>
                        <div class="topic-plus" v-if="currentTopic.fill">
                            <span v-if="currentTopic.fill.blankIgnoreCase=='N'">*答案区分字母大小写</span>
                            <span v-if="currentTopic.fill.blankIgnoreOrder=='Y'">*答案不区分多个空的先后顺序</span>
                        </div>
                    </div>
                    
                    <template v-if="currentTopic.createType == 'PHOTO'">
                        <div class="t-photo">
                            <img :src="a.attachmentUrl" alt="" v-for="(a, i) in currentTopic.attachments" :key="i" :width="a.metaWidth" :height="a.meteHeight">
                        </div>
                    </template>

                    <template v-else>
                        <div class="topic-subject rtf" v-html="currentTopic.subject"></div>
                    </template>

                    <template v-if="currentTopic.type == TYPE.SINGLE || currentTopic.type == TYPE.MULTI">
                        <template v-if="currentTopic.createType == 'PHOTO'">
                            <div class="pic-opt">{{ currentTopic.picOption.filter(o => o.isAnswer).map(o => o.key ).join('') }}</div>
                        </template>

                        <template>
                            <div class="option-box">
                                <div v-for="(o, index) in currentTopic.options" :key="o.id" :class="{'is-answer': o.isAnswer}" class="option">
                                    <div class="item-no"><div>{{ String.fromCharCode(index + 65) }}</div></div>
                                    <div ref="contentRtf" class="content rtf" v-html="o.content"></div>
                                </div>
                            </div>
                        </template>
                    </template>

                    <template v-if="currentTopic.type == TYPE.TF">
                        <div class="tf-item tf-right tf-answer" v-if="currentTopic.tfAnswer == 'T'">正确</div>
                        <div class="tf-item tf-wrong tf-answer" v-if="currentTopic.tfAnswer == 'F'">错误</div>
                    </template>

                    <template v-if="currentTopic.type == TYPE.FILL && currentTopic.fill && currentTopic.fill.blankAlternatives">
                        <div class="fill-item" v-for="(f, i) in currentTopic.fill.blankAlternatives" :key="i">
                            <div class="fill-label">{{ `填空 ${i + 1}` }}</div>
                            <div class="fill-con">{{ f.content }}</div>
                        </div>
                    </template>

                    <div v-if="currentTopic.analysis != null && currentTopic.analysis.length > 0" class="analysis">
                        <div class="label"><div>解析</div></div>
                        <div class="content rtf " v-html="currentTopic.analysis"></div>
                    </div>

                    <div v-if="currentTopic.kps != null && currentTopic.kps.length > 0" class="kps">
                        <div class="label"><div>知识点</div></div>
                        <div class="content rtf " v-html="currentTopic.kps.map(k => k.kp).join(',')"></div>
                    </div>

                    <!-- <div class="option-box" @click.capture="onRichContentClick">
                        <div v-for="(o, index) in currentTopic.options" :key="o.id" :class="{'is-answer': o.isAnswer}" class="option">
                            <div class="item-no"><div>{{ String.fromCharCode(index + 65) }}</div></div>
                            <div class="content rtf" v-html="o.content"></div>
                        </div>
                    </div>

                    <div v-if="currentTopic.analysis != null && currentTopic.analysis.length > 0" class="analysis" @click.capture="onRichContentClick">
                        <div class="label"><div>解析</div></div>
                        <div class="content rtf light-gray" v-html="currentTopic.analysis"></div>
                    </div> -->
                </div>
            </div>
        </div>
        
        <!-- The quiz stat layer -->
        <div v-if="currentLayer === 'quiz-stat'" class="quiz-stat-layer layer">
            <div class="title-bar">
                <div class="title">{{ title }}</div>
            </div>
            <div class="content-box">
                <div class="total-stat-box">
                    <div class="total-stat-row">
                        <div class="score-duration-box">
                            <div class="data">{{ quizStat.avgScore }}</div>
                            <div class="label">百分制平均分</div>
                            <div class="sep"></div>
                            <div class="data">{{ formatDuration(quizStat.avgDuration) }}</div>
                            <div class="label">平均用时</div>
                        </div>
                        <div class="score-range-box">
                            <div class="title">百分制区间-人数分布图</div>
                            <div class="bar-chart">
                                <div v-for="s in scoreRangeStat" :key="s.label" class="bar-box">
                                    <div class="data">{{ s.data }}</div>
                                    <div class="bar" :style="calcBarHeight(s.data)"></div>
                                    <div class="label">{{ s.label }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="section-title">单题分析（{{ topicAccuracyStatSortBy === 'displayOrder' ? '按出题顺序排列' : '按正确率由低到高排列' }}）</div>

                    <div class="topic-accuracy-box">
                        <div v-for="s in topicAccuracyStat" :key="s.id" class="topic-accuracy">
                            <div class="circle-chart">
                                <svg version="1.1"
                                     baseProfile="full"
                                     width="1" height="1"
                                     viewBox="0 0 1 1"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g transform="translate(0.5, 0.5) rotate(-90)">
                                        <circle cx="0" cy="0" r="0.457" stroke="#7b7b7b" fill="transparent" stroke-width="0.0857" />
                                        <path :d="calcCirclePath(s.accuracy)" :stroke="calcCircleColor(s.accuracy)" fill="transparent" stroke-width="0.0857" stroke-linecap="round" />
                                    </g>
                                    <text x="0.5" y="0.58" text-anchor="middle" fill="#fff" font-size="0.2571">{{ s.accuracyString }}%</text>
                                </svg>
                            </div>
                            <div class="info">
                                <div style="padding-bottom: 14px;">第 {{ s.displayOrder + 1 }} 题</div>
                                <div>正确率：{{ s.accuracyString }}%</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 个人结果统计 -->
        <div v-if="currentLayer === 'user-stat' && currentUser != null" class="user-stat layer">
            <div class="title-bar">
                <div class="title">{{ title }}</div>
            </div>
            <div class="content-box">
                <div class="user-stat-box">
                    <div class="user-stat-row">
                        <div class="avatar-col" :class="{'rank1': currentUser.rank === 1, 'rank2': currentUser.rank === 2, 'rank3': currentUser.rank === 3}">
                            <div class="avatar">
                                <img :src="currentUser.avatarUrl" alt="" class="avatar">
                            </div>
                            <div class="info-col">
                                <div class="name">{{ currentUser.fullName }}</div>
                                <div class="sno">{{ currentUser.studentNo }}</div>
                            </div>
                        </div>
                        <div class="stat-col">
                            <div class="data-col">
                                <div class="data">{{ currentUser.score }}</div>
                                <div class="label">测试得分</div>
                            </div>
                            <div class="data-col">
                                <div class="data">{{ paperScore }}</div>
                                <div class="label">卷面总分</div>
                            </div>
                            <div class="data-col">
                                <div class="data">{{ currentUser.score100 }}</div>
                                <div class="label">百分制得分</div>
                            </div>
                            <div class="data-col">
                                <div class="data">{{ formatDuration(currentUser.duration) }}</div>
                                <div class="label">用时</div>
                            </div>
                        </div>
                    </div>

                    <div class="user-topic-box clearfix">
                        <div v-for="r in currentUser.results" :key="r.id" class="user-topic">
                            <div class="user-topic-t" :class="{'right': r.userResult == 1, 'wrong': r.userResult == 0 || r.userResult == -1, 'part-right': r.userResult == -2}">
                                <template v-if="r.type == TYPE.SINGLE || r.type == TYPE.MULTI">
                                    <div class="user-answer choice">
                                        {{ r.displayOrder + 1 }}. {{ r.choicesString || '未作答' }}
                                    </div>
                                    <div class="score">{{ r.score }} 分</div>
                                </template>

                                <template v-if="r.type == TYPE.TF">
                                    
                                    <div class="user-answer user-tf">{{ r.displayOrder + 1 }}. {{ r.userResult == -1 ? '未作答' : r.tfAnswer == 'T' ? '正确' : '错误' }}</div>
                                    <div class="score">{{ r.score }} 分</div>
                                </template>

                                <template v-if="r.type == TYPE.FILL">
                                    <div class="user-answer user-fill">{{ r.displayOrder + 1 }}. {{ r.blanks.map(b => b.content || '未作答').join('；') }}</div>
                                    <div class="score">{{ r.score }} 分</div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 题目统计分析 -->
        <div v-if="currentLayer === 'topic-stat'" class="topic-stat layer">
            <div class="title-bar">
                <div class="title">{{ title }} - 题目 {{ currentAnalyzeTopic.displayOrder + 1 }}</div>
            </div>
            <div class="content-box">
                <div class="topic-stat-box">
                    <div class="pie-chart-box">
                        <div class="title">
                            <div class="label" v-if="currentAnalyzeTopic.type !== TYPE.FILL">选项分布</div>
                            <div class="label" v-else>每空正确率</div>
                            <div class="legend"></div>
                            <div class="label">蓝色为正确答案</div>
                        </div>

                        <template v-if="isShowFillNoAnswer">
                            <div class="fill-no-answer">没有人作答</div>
                        </template>

                        <template v-else>
                            <echarts v-if="currentAnalyzeTopic.type !== TYPE.FILL" ref="topicAnalyzePieChart" :options="topicAnalyzePieChartOptions" class="pie-chart" />
                            <echarts v-if="currentAnalyzeTopic.type == TYPE.FILL" ref="topicAnalyzeBarChart" :options="topicAnalyzeBarChartOptions" class="bar-chart pie-chart" />
                        </template>
                    </div>
                    <div class="topic-container" @click.capture="onRichContentClick">
                        <div class="topic-box" :class="{'moso-latex': currentAnalyzeTopic.latexIncluded == 'Y'}">
                            <template v-if="currentAnalyzeTopic.createType == 'PHOTO'">
                                <div class="t-photo">
                                    <img :src="a.attachmentUrl" alt="" v-for="(a, i) in currentAnalyzeTopic.attachments" :key="i" :width="a.metaWidth" :height="a.meteHeight">
                                </div>
                            </template>

                            <template v-else>
                                <div class="topic-subject rtf" v-html="currentAnalyzeTopic.subject"></div>
                            </template>

                            <div class="fill-plus" v-if="currentAnalyzeTopic.fill">
                                <span v-if="currentAnalyzeTopic.fill.blankIgnoreCase=='N'">*答案区分字母大小写</span>
                                <span v-if="currentAnalyzeTopic.fill.blankIgnoreOrder=='Y'">*答案不区分多个空的先后顺序</span>
                            </div>

                            <template v-if="currentAnalyzeTopic.type == TYPE.SINGLE || currentAnalyzeTopic.type == TYPE.MULTI">
                                <template v-if="currentAnalyzeTopic.createType == 'PHOTO'">
                                    <div class="pic-opt">{{ currentAnalyzeTopic.picOption.filter(o => o.isAnswer).map(o => o.key ).join('') }}</div>
                                    <!-- <div class="pic-opt" v-for="(o, i) in currentAnalyzeTopic.picOption" :key="i" :class="{'pic-opt-right': o.isAnswer}">{{ o.key }}</div> -->
                                </template>

                                <template>
                                    <div class="option-box">
                                        <div v-for="(o, index) in currentAnalyzeTopic.options" :key="o.id" :class="{'is-answer': o.isAnswer}" class="option" 
                                            v-show="!(currentAnalyzeTopic.createType == 'PHOTO' && !o.isAnswer)">
                                            <div class="item-no"><div>{{ String.fromCharCode(index + 65) }}</div></div>
                                            <div ref="contentRtf" class="content rtf" v-html="o.content"></div>
                                        </div>
                                    </div>
                                </template>
                            </template>

                            <template v-if="currentAnalyzeTopic.type == TYPE.TF">
                                <div class="tf-item tf-right tf-answer" v-if="currentAnalyzeTopic.tfAnswer == 'T'">正确</div>
                                <div class="tf-item tf-wrong tf-answer" v-if="currentAnalyzeTopic.tfAnswer == 'F'">错误</div>
                            </template>

                            <template v-if="currentAnalyzeTopic.type == TYPE.FILL && currentAnalyzeTopic.fill && currentAnalyzeTopic.fill.blankAlternatives">
                                <div class="fill-item" v-for="(f, i) in currentAnalyzeTopic.fill.blankAlternatives" :key="i">
                                    <div class="fill-label">{{ `填空 ${i + 1}` }}</div>
                                    <div class="fill-con">{{ f.content }}</div>
                                </div>
                            </template>

                            <div v-if="currentAnalyzeTopic.analysis != null && currentAnalyzeTopic.analysis.length > 0" class="analysis">
                                <div class="label"><div>解析</div></div>
                                <div class="content rtf " v-html="currentAnalyzeTopic.analysis"></div>
                            </div>

                            <div v-if="currentAnalyzeTopic.kps != null && currentAnalyzeTopic.kps.length > 0" class="kps">
                                <div class="label"><div>知识点</div></div>
                                <div class="content rtf " v-html="currentAnalyzeTopic.kps.map(k => k.kp).join(',')"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showHint && currentLayer === 'rank'" class="hint-layer">
            <div class="hint-content">{{ hintContent }}</div>
        </div>
        
        <div v-if="hasImage" class="expand-image-box">
            <img ref="selectedImage" :src="selectedImage.src" alt="" :style="selectedImage.styleString" :class="selectedImage.src == loading ? 'imgAnimation' : ''">
        </div>

        <resourceAudio id="quiz-audio" class="quiz-audio" v-if="(currentLayer === 'topic' || 'topic-stat') && hasAudio" :current-show="currentShow" :quizAudioData="quizAudioData"/>
    </div>
</template>

<script type="text/javascript">
import ledTimer from './ledTimer.vue';
import resourceAudio from './resourceAudio.vue';
import tool from '../assets/scripts/tool.js';
import Vue from 'vue';
import ECharts from 'vue-echarts/components/ECharts';

import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/dataZoom';

import defaultAvatar from '../assets/image/default-avatar.png';
import loading from '@/assets/image/loading.png';

const TYPE = {
    SINGLE: 'SINGLE',
    MULTI: 'MULTI',
    TF: 'TF',
    FILL: 'FILL',
}

export default {
    components: {
        ledTimer,
        resourceAudio,
        echarts: ECharts
    },
    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        currentShow: {
            type: String,
            default: ''
        }
    },

    data: function() {
        return {
            // Quiz Data
            id: null,
            clazzCourseId: null,
            memberCount: '',
            title: null,
            titlePlus: '',
            TYPE: TYPE,
            DEFALUT_FILL_COUNT: 7,
            isShowFillNoAnswer: false,
            status: null,
            score: 0,
            paperScore: 0,
            startTime: null,
            endTime: null,
            autoEnd: null,
            autoEndTime: null,
            memberCount: 0,
            topics: [],
            results: [],
            quizStat: {
                avgScore: 0,
                avgDuration: 0
            },
            topicType: '',
            highestScore: 0,
            highestMemberCount: 0, // the highest member count in score range
            scoreRangeStat: [],
            topicAccuracyStat: [],
            topicAccuracyStatSortBy: 'displayOrder', // sort topics in the quiz stat by displayOrder or pct
            // selected data
            currentTopic: null,
            currentUser: null,
            currentAnalyzeTopic: {
                subject: 'this is the topic subject',
                displayOrder: 0,
                answerVal: 16384,
                options: [{
                    id: '1',
                    content: 'Blue',
                    isAnswer: true
                }, {
                    id: '2',
                    content: 'Red',
                    isAnswer: false
                }]
            },
            topicAnalyzePieChartOptions: {
                backgroundColor: '#444444',
                textStyle: {
                    color: '#FF9900',
                    fontSize: 18,
                },
                series: [{
                    type: 'pie',
                    roseType: 'radius',
                    radius: '45%',
                    data: [],
                    avoidLabelOverlap: true,
                    label: {
                        textStyle: {
                            color: '#ff9900'
                        },
                        rich: {
                            t: {
                                color: '#ff9900',
                                fontSize: 18
                            },
                            pc: {
                                color: '#BBC2C6',
                                fontSize: 18,
                                lineHeight: 24
                            }
                        },
                        formatter: function(d) {
                            return '{t|' + d.name + '. ' + d.data.percentString + '%}\n{pc|' + d.data.chosenCount + ' 人选择}';
                        }
                    },
                    labelLine: {
                        lineStyle: {
                            color: '#BBC2C6'
                        },
                        smooth: 0.2,
                        length: 17,
                        length2: 20
                        // smooth: false
                    },
                    itemStyle: {
                        color: '#BBC2C6',
                        shadowBlur: 20,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },
                }]
            },
            topicAnalyzeBarChartOptions: {
                backgroundColor: '#444444',
                textStyle: {
                    color: '#FF9900',
                    fontSize: 20,
                },
                grid: {
                    left: 80
                },
                xAxis: {
                    type: 'category',
                    data: [],
                    axisLabel: {
                        textStyle: {
                            color: '#fff',
                            fontSize: 20
                        }
                    },
                    splitLine:{
                        show:false
                    },
                    axisLine:{
                        lineStyle:{
                            color:"#cccccc",
                            // opacity:0.5
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine:{
                        show:false
                    },
                    axisLine:{
                        lineStyle:{
                            color:"#cccccc",
                            // opacity:0.5
                        }
                    },
                    axisLabel:{
                        formatter: (value) => {
                            if (value == 1) {
                                return '100%'
                            } else {
                                return ''
                            }
                        },
                        textStyle: {
                            color: '#fff',
                            fontSize: 20
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    max: 1
                },
                series: [{
                    type: 'bar',
                    barWidth: 30,
                    data: [],
                    itemStyle: {
                        color: '#53A2F2'
                    },
                    label: {
                        show: true,
                        position: 'top',
                        formatter: (value) => {
                            return (+value.data * 100).toFixed(0) + '%' 
                        },
                        color: '#fff',
                        fontSize: 20
                    },
                }]
            },
            pieChart: null, // topic analyze right rate pie chart
            // if timerRequired should be set to true in N seconds, we set a timer to do this, so save the timerId and if this component is hidden, clear it
            timerId: 0, 
            timerRequired: false,
            timeInSeconds: 0,
            defaultAvatar: defaultAvatar,
            serverTimestamp: 0,
            currentLayer: 'rank',
            componentId: null,
            isFirefox: navigator.userAgent.indexOf('Firefox/') > 0,
            // events
            supportedEventNames: [
                'activity.quiz.show',
                'activity.quiz.showTopic',
                'activity.quiz.showUserResult',
                'activity.quiz.showAnalyze',
                'activity.quiz.showTopicAnalyze',
                'activity.quiz.newResult',
                'activity.quiz.sortBy',
                'common.moveJoystick',
                'files.zoom',
                'files.rotate',
                'quiz.files.show',
                'quiz.audio.hide'
            ],
            currentType: '',
            hasImage: '',
            selectedImage: [],
            hasAudio: false,
            quizAudioData: null,
            loading: loading,
            factor: '',
            moveX: 0,
            moveY: 0,
            rotate: 0,
        };
    },

    computed: {
        /**
         * The hint box style string
         * @return {string} the style string
         */
        hintStyleString: function() {
            let h = window.innerHeight - 80;
            return 'height: ' + h + 'px;';
            /*
            let w = window.innerWidth;
            const hw = 200;
            const hh = 250;
            if (h < 0 || h < hh) h = 0;
            if (w < 0 || w < hw) w = 0;
            return 'height: ' + h + 'px; padding-left: ' + Math.round((w - hw) / 2) + 'px; padding-top: ' + Math.round((h - hh) / 2) + 'px;';
            */
        },

        hintContent: function() {
            return this.status === 'END' ? '很遗憾，没有同学参与测试' : '快来参与测试吧～';
        },

        showHint: function() {
            return this.results.length === 0;
        },


    },

    watch: {
        currentShow: function(newVal, oldVal) {
            if (newVal != this.componentId && oldVal === this.componentId) {
                if (this.timerId > 0) clearTimeout(this.timerId);

                this.$refs.quizBox.scrollTop = 0;

                this.timerRequired = false;
            }
        },

        topicAccuracyStatSortBy: function(newVal) {
            if (this.topicAccuracyStat.length > 1) {
                if (newVal === 'displayOrder') {
                    this.topicAccuracyStat.sort((a, b) => a.displayOrder - b.displayOrder);
                } else if (newVal === 'pct') {
                    this.topicAccuracyStat.sort((a, b) => a.accuracy - b.accuracy);
                }
            }
        },

        currentLayer: function(newVal) {
            if (newVal !== 'topic') this.hasAudio = false;
        }
    },

    created: function() {
        window.addEventListener('message', this.windowMessageHandler);
    },

    mounted: function() {
        this.componentId = this.$attrs.id;
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);  
    },

    
    methods: {
        formatDuration: function(d) {
            return tool.formatTimeAsDurationString(d);
        },

        calcCircleColor: function(pct) {
            if (0.00 <= pct && pct <= 0.25) return '#FA4242';
            if (0.25 <  pct && pct <= 0.50) return '#FF6600';
            if (0.50 <  pct && pct <= 0.75) return '#FF6600';
            if (0.75 <  pct && pct <= 1.00) return '#53A2F2';
            return '#7b7b7b';  
        },
        /**
         * Quiz total ayalyze, topic right rate, circle
         * @param  {number} pct number bewteen 0 and 1
         * @return {string}     the path string for svg
         */
        calcCirclePath: function(pct) {
            let s = 'M 0.457 0 A 0.457 0.457 0';

            // large-arc-flag
            if (pct > 0.5) {
                s += ' 1';
            } else {
                s += ' 0';
            }

            // sweep-flag
            s += ' 1';

            // target x and y
            const r = 0.45714;
            let alpha = Math.PI * 2 * pct;
            let x = r * Math.cos(alpha);
            let y = r * Math.sin(alpha);

            // SVG Path + Arc 当需要画一个非常接近整圆的弧线时，会画错……所以，如果是超过 3/4 圆的，我们用两段弧线拼接一下
            if (pct > 0.75) {
                s += ' 0 -0.457 M 0 -0.457 A 0.457 0.457 0 0 1';
            }

            s += ' ' + x + ' ' + y;
            return s;
        },  
        /**
         * Calculate the quiz stat score range bar height
         * @param  {number} c the member count
         * @return {string}   height style
         */
        calcBarHeight: function(c) {
            if (this.highestMemberCount === 0) return 'height: 0px;';
            const maxHeight = 120;
            const s = 'height: ' + Math.round((c / this.highestMemberCount) * maxHeight) + 'px;';
            return s;
        },
        /**
         * Calculate if the timer is required
         * @return {void} No return value, just this.timerRequired is modified or modified later
         */
        calcTimerRequired: function() {
            if (this.timerId > 0) clearTimeout(this.timerId);

            if (this.status !== 'IN_PRGRS' || this.autoEnd !== 'Y') {
                this.timerRequired = false;
                return;
            }

            if (! this.autoEndTime) {
                console.log('invalid auto end time found');
                return;
            }

            const now = Date.now();
            const endTime = (new Date(this.autoEndTime)).getTime();
            if (now >= endTime) {
                this.timerRequired = false;
                return;
            }

            const d = endTime - now;
            if (d <= 3600000) {
                this.timerRequired = true;
                this.timeInSeconds = Math.round(d / 1000);
                return;
            }

            this.timerId = setTimeout(() => {
                this.timerRequired = true;
                this.timeInSeconds = 3600;
            }, (endTime - now) - 3600000);
        },
        /**
         * Sort my results
         * @param {array} results the results collection to sort
         * @return {void} 
         */
        sortResults: function(results) {
            results.sort((a, b) => {
                if (a === b) return 0;
                if (a == null && b != null) return -1;
                if (a != null && b == null) return 1;
                // submitted first, then unsubmitted
                if (a.duration > 0 && b.duration <= 0) return -1;
                // both unsubmitted, compare by student no
                if (a.duration <= 0 && b.duration <= 0) return a.user.studentNo.localeCompare(b.user.studentNo);

                let d = b.score - a.score;
                if (d != 0) return d; // higher score first
                // if the results have same score, shorter duration first
                d = a.duration - b.duration;
                if (d != 0) return d;
                // finally, if the score and duration are the same, sort by student no
                return a.user.studentNo.localeCompare(b.user.studentNo);
            });
        },

        /**
         * Set the results rank
         * you must sort the results first, than set rank
         */
        setRank: function(results) {
            if (results.length === 0) return;
            let lastResult = results[0];
            lastResult.rank = 1;
            for (let i = 1, n = results.length; i < n; i++) {
                let result = results[i];
                if (result.score === lastResult.score && result.duration === lastResult.duration) {
                    result.rank = lastResult.rank;
                } else {
                    result.rank = lastResult.rank + 1;
                }
                lastResult = result;
            }
        },

        getTopicTypeString: function(typeCode) {
            if (typeCode === 'SINGLE') return '单选';
            if (typeCode === 'MULTI') return '多选';
            if (typeCode === 'TF') return '判断';
            if (typeCode === 'FILL') return '填空';
            return 'UNKNOWN';
        },

        /**
         * The a link, image, audio elements in rich content are clicked
         * @param  {Object} evt the click event
         * @return {void}     
         */
        onRichContentClick: function(evt) {
            // console.log(evt.target.tagName);
            evt.preventDefault();
            evt.stopPropagation();
        },

        windowMessageHandler: function(e) {
            const msg = e.data;
            if ( ! msg || ! msg.eventName || this.supportedEventNames.indexOf(msg.eventName) === -1) return;
            if (this.isLock && this.currentShow === this.componentId) return;
            // console.log(msg.eventName, msg.data);
            const msgData = msg.data;
            switch (msg.eventName) {
                case 'activity.quiz.show':
                    this.titlePlus = '';
                    this.handleShowQuizMessage(msgData);
                    break;
                case 'activity.quiz.showTopic':
                    if (msgData.id === this.id) {
                        this.handleShowTopicMessage(msgData);
                    }
                    break;
                case 'activity.quiz.showUserResult':
                    this.titlePlus = '';
                    if (msgData.id === this.id) {
                        this.handleShowUserResultMessage(msgData);
                    }
                    break;
                case 'activity.quiz.showAnalyze':
                    if (msgData.id === this.id) {
                        this.handleShowAnalyzeMessage(msgData);
                    }
                    break;
                case 'activity.quiz.showTopicAnalyze':
                    if (msgData.id === this.id) {
                        this.handleShowTopicAnalyzeMessage(msgData);
                    }
                    break;
                case 'activity.quiz.newResult':
                    if (msgData.id === this.id) {
                        this.handleNewResultMessage(msgData);
                    }
                    break;
                case 'activity.quiz.sortBy':
                    if (msgData.id === this.id) {
                        this.topicAccuracyStatSortBy = msgData.sortBy === 'TOPIC' ? 'displayOrder' : 'pct';
                    }
                    break;
                case 'common.moveJoystick':
                    this.moveJoystick(msgData);
                    break;
                case 'files.zoom':
                    if (msgData.entityId !== this.id) return;
                    this.zoomTo(msgData);
                    break;
                case 'files.rotate':
                    if (msgData.entityId !== this.id) return;
                    this.rotateImg(msgData);
                    break;
                case 'quiz.files.show':
                    if (msgData.entityId === this.id) {
                        if (msgData.quizLinkType === 'AUDIO') {
                            this.showFilesAudio(msgData);
                        } else if (msgData.quizLinkType === 'IMG') {
                            this.hasImage = true;
                            this.showFilesImage(msgData);
                        } else {
                            return;
                        }
                    }
                    break;
                case 'quiz.audio.hide':
                    if (msgData.entityId === this.id) {
                        if (msgData.id === this.selectedImage.relationId) {
                            if (this.hasImage) this.hasImage = false;
                            this.moveX = 0;
                            this.moveY = 0;
                            this.rotate = 0;
                        } else {
                            if (this.hasAudio) this.hasAudio = false;
                        }
                    }
                default:
                    // statements_def
                    break;
            }
        },

       
        /**
         * Set the option isAnswer property
         * @param {Array} options   the options, ordered by display order
         * @param {number} answerVal the right answer val in number format of the topic
         */
        setOptionsIsAnswerFlag: function(options, answerVal) {
            if (! options) return;
            let val = 0b0100000000000000;
            options.forEach(o => {
                o.isAnswer = ((answerVal & val) === val);
                val = val >> 1;
            });
        },

        parseChoiceAnswer(answerVal, optionCount) {
            if (!answerVal || !optionCount) return [];
            let val = 0b0100000000000000;
            let ops = [];
            for (let i = 0; i < 15; i++) {
                ops.push({
                    itemNo: i,
                })
            }
            ops.forEach(o => {
                o.isAnswer = ((answerVal & val) === val);
                val = val >> 1;
            });
            
            let letter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            let result = [];
            for (let i = 0; i < optionCount; i++) {
                result.push({
                    key: letter[i],
                    isAnswer: ops[i].isAnswer
                });
            }

            return result;
        },

        /**
         * Convert answer val to options string, e.g. 16384 => A  18432 => AD
         * @param  {number} answerVal the answer val
         * @return {string}           uppercase options number string
         */
        answerValToOptionString: function(answerVal) {
            let bits = answerVal.toString(2);
            let chars = [];
            const startCode = 15 - bits.length + 65;
            bits.split('').forEach((b, index) => chars.push(b === '1' ? String.fromCharCode(index + startCode) : ''));
            return chars.join('');
        },

        /**
         * Generate the single topic chosen option distribution data for piechart
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/03act/03quiz/#3-3-5}
         * @param  {Array} pcts option chosen stat data
         * @return {void}      
         */
        generateTopicOptionPieChartData: function(type, pcts, answerVal) {
            console.log('generateTopicOptionPieChartData', type, pcts, answerVal)
            if (! pcts || !type) return [];

            let data;
            switch (type) {
                case TYPE.SINGLE:
                case TYPE.MULTI:
                    let ops = pcts.data || [];
                    let joinCount = 0;
                    // data = ops.filter(p => p.chosenCount > 0).map(p => {
                    data = ops.filter(p => p.pct > 0 && p.itemNos).map(p => {
                        joinCount+=p.chosenCount;
                        const obj = {
                            value: Math.round(p.pct * 100),
                            name: p.itemNos && p.itemNos.map(n => String.fromCharCode(n + 65)).join('') || '未作答',
                            percentString: (p.pct * 100).toFixed(2),
                            chosenCount: p.chosenCount
                        };
                        return obj;
                    });

                    console.log(pcts)
                    if (pcts.totalCount > joinCount) {
                        let pct = (pcts.totalCount - joinCount) / pcts.totalCount;
                        let noAnswer = {
                            value: Math.round(pct * 100),
                            name: '未作答',
                            percentString: (pct * 100).toFixed(2),
                            chosenCount: pcts.totalCount - joinCount
                        }
                        data.push(noAnswer);
                    }
                    
                    const answerString = this.answerValToOptionString(answerVal);
        
                    data.forEach(d => {
                        if (d.name === answerString) {
                            d.isAnswer = true;
                            d.itemStyle = {color: '#53A2F2'};
                        } else {
                            d.isAnswer = false;
                        }
                    });
        
                    data.sort((a, b) => {
                        if (a === b) return 0;
                        if (a == null && b != null) return -1;
                        if (a != null && b == null) return 1;
                        // right answer last
                        // if (a.isAnswer) return 1;
                        // if (b.isAnswer) return -1;
                        // not answer, sort by chosen member count. less is first
                        return a.value - b.value;
                    });
                    break;
                case TYPE.TF:
                    data = [];
                    let options = pcts; 
                    let rightCount = +options.rightCount;
                    let wrongCount = +options.wrongCount;
                    let totalCount = +options.totalCount;
                    let rightData = {
                        name: options.answer == 'T' ? '正确' : '错误',
                        isAnswer: true,
                        percentString: ((+options.rightPct) * 100).toFixed(2),
                        value: options.rightPct * 100,
                        chosenCount: rightCount,
                        itemStyle: {color: '#53A2F2'} 
                    }
                    let falseData = {
                        name: options.answer == 'T' ? '错误' : '正确',
                        isAnswer: false,
                        percentString: ((+options.wrongPct) * 100).toFixed(2),
                        value: options.wrongPct * 100,
                        chosenCount: wrongCount,
                    }
                    rightCount && data.push(rightData);
                    wrongCount && data.push(falseData);
                    if (totalCount < this.memberCount) {
                        data.push({
                            name: '未作答',
                            isAnswer: false,
                            percentString: ((+options.emptyPct) * 100).toFixed(2),
                            value: options.emptyPct * 100,
                            chosenCount: totalCount - rightCount - wrongCount,
                        })
                    }
                    break;
                case TYPE.FILL:
                    let xData = [];
                    let statData = [];
                    let dataZoom = {};
                    let grid = {left: 80};
                    if (pcts) {
                        let count = 0;
                        for (let key in pcts) {
                            let blank = pcts[key];
                            xData.push(`填空 ${+key + 1}`);
                            statData.push(blank.pct);
                            count++;
                        }

                        if (count > this.DEFALUT_FILL_COUNT) {
                            dataZoom = [
                                {
                                    show: true,
                                    realtime: true,
                                    height: 20,
                                    startValue: 0,
                                    showDetail: false,
                                    endValue: this.DEFALUT_FILL_COUNT
                                }
                            ];
                            dataZoom = {
                                show: true,
                                realtime: true,
                                height: 20,
                                startValue: 0,
                                showDetail: false,
                                endValue: this.DEFALUT_FILL_COUNT
                            }
                            grid.bottom = 80;
                        } else {
                            dataZoom = [];
                            
                        }
                    }
                    data = {
                        xData,
                        statData,
                        dataZoom,
                        grid
                    }
                    break;
            }
            console.log('seies', data)
            return data;
        },


        handleNewResultMessage: function(msgData) {
            if ( ! msgData) return;
            const data = JSON.parse(JSON.stringify(msgData));
            if ( ! data.result) return;

            const result = data.result;
            result.score100 = this.paperScore > 0 ? Math.round(result.score * 100 / this.paperScore) : 0;
            const index = this.results.findIndex(r => r.user.id === data.result.user.id);
            if (index >= 0) {
                this.results.splice(index, 1, result);
            } else {
                this.results.push(result);
            }
            this.sortResults(this.results);
            this.setRank(this.results);

        },
        /**
         * Show 1 topic analyze
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/03act/03quiz/#3-3-5}
         * @param  {Object} msgData the message data
         * @return {void}         
         */
        handleShowTopicAnalyzeMessage: function(msgData) {
            console.log('handleShowTopicAnalyzeMessage', msgData)
            if (! msgData) return;
            const data = JSON.parse(JSON.stringify(msgData));
            delete data.id;
            data.id = data.topicId;
            if (data.createType == 'PHOTO') {
                data.picOption = this.parseChoiceAnswer(data.answerVal, data.optionCount);
            } else {
                this.setOptionsIsAnswerFlag(data.options, data.answerVal);
            }

            // handle chart
            const pieChartData = this.generateTopicOptionPieChartData(data.type, data.pcts, data.answerVal);
            this.isShowFillNoAnswer = false;
            if (data.type == TYPE.FILL) {
                this.topicAnalyzeBarChartOptions.xAxis.data = pieChartData.xData;
                this.topicAnalyzeBarChartOptions.dataZoom = pieChartData.dataZoom;
                this.topicAnalyzeBarChartOptions.grid = pieChartData.grid;
                if (pieChartData.statData.length) {
                    this.topicAnalyzeBarChartOptions.series[0].data = pieChartData.statData;
                } else {
                    this.isShowFillNoAnswer = true;
                }
            } else {
                this.topicAnalyzePieChartOptions.series[0].data = pieChartData;
            }
            
            if (data.latexIncluded !== 'Y' && this.judgeLatex(data)) {
                data.latexIncluded = 'Y';
            }

            //handle kps/analysis
            if (!data.kps || !data.kps.length) {
                data.kps = [{id: -1, kp: '暂无知识点'}]
            }
            data.analysis = data.analysis || '暂无解析';
            
            this.currentAnalyzeTopic = data;
            this.topicType = data.type;
            this.titlePlus = ` - 题目 ${data.displayOrder + 1}`;


            this.currentLayer = 'topic-stat';

            Vue.nextTick(() => {
                // if (! this.isFirefox) {
                //     com.wiris.js.JsPluginViewer.doLoad();
                // }
                // Prism.highlightAll();
                this.convertMML2SVG();
            });    
        },

        judgeLatex(data) {
            let mathReg = /(<math[\s\S]*?>)([\s\S]*?)(<\/math>)/gi;
            let hasMath = false;

            let b1 = mathReg.test(data.subject);
            let b2 = mathReg.test(data.analysis);
            let b3 = false;
            if (Array.isArray(data.options)) {
                for (let i = 0; i < data.options.length; i++) {
                    const o = data.options[i];
                    let content = o.content || '';
                    if (mathReg.test(content)) {
                        b3 = true;
                        break;
                    }
                }
            }
            hasMath = b1 || b2 || b3;
            if (hasMath) {
                data.latexIncluded = 'Y';
            }
            return hasMath;
        },

        /**
         * Convert all of the mathml to svg for browser compatibility
         * @return {void} 
         */
        convertMML2SVG: function() {
            tool.parseDocument();
            // const mmlElements = document.querySelectorAll('math');
            // console.log('mathml elements:', mmlElements.length);
            // if (mmlElements.length === 0) return;

            // // default font size of formula is 24, and default font size of document is 16px. so the formula font size is 1.5 times document font size
            // let fontSize = '24px';
            // if (document.querySelector('html').style.fontSize != '') {
            //     fontSize = (parseInt(document.querySelector('html').style.fontSize) * 1.5) + 'px';
            // }

            // let index = 0;
            // const _convert = mmlEle => {
            //     const baseUrl = 'https://wiris-server.mosoteach.cn:2222/editor/render.svg?mml=';
            //     mmlEle.setAttribute('mathsize', fontSize);
            //     mmlEle.setAttribute('style', 'font-family: stix');

            //     // the formula's color follows its' parent color
            //     let mathColor = '#ffffff';
            //     if (mmlEle.parentElement) {
            //         mathColor = window.getComputedStyle(mmlEle.parentElement).color;
            //         if (mathColor) {
            //             const parts = mathColor.match(/^rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)$/);
            //             if (parts) {
            //                 parts.shift();
            //                 mathColor = '#' + parts.map(s => ('0' + parseInt(s).toString(16)).slice(-2)).join('');
            //             }
            //         }
            //     }

            //     mmlEle.setAttribute('mathcolor', mathColor);
                

            //     const mml = mmlEle.outerHTML;
            //     this.$http.get(baseUrl + encodeURIComponent(mml))
            //         .then(response => {
            //             const svgSource = response.data;
            //             const spanElement = document.createElement('SPAN');
            //             spanElement.setAttribute('class', 'mml-svg-box');
            //             spanElement.innerHTML = svgSource;
            //             const parentElement = mmlEle.parentElement;
            //             if (parentElement) {
            //                 parentElement.replaceChild(spanElement, mmlEle);    
            //             }
                        
            //             index += 1;
            //             if (index < mmlElements.length) {
            //                 _convert(mmlElements[index]);
            //             }
            //         })
            //         .catch(err => {
            //             console.log('error occured while convert mml to svg', err);
            //             index += 1;
            //             if (index < mmlElements.length) {
            //                 _convert(mmlElements[index]);
            //             }
            //         });
            // };
            // const nextElement = mmlElements[index];
            // _convert(nextElement);
        },

        /**
         * Quiz total analyze and stat layer
         * @param  {Object} msgData the message data
         * @return {void}         
         */
        handleShowAnalyzeMessage: function(msgData) {
            if (this.results.length == 0 || this.paperScore === 0) return;

            let c = this.results.map(r => r.score).reduce((acc, cur) => acc + cur);
            c = c * (100 / this.paperScore);
            this.quizStat.avgScore = (c / this.results.length).toFixed(1);
            c = this.results.map(r => r.duration).reduce((acc, cur) => acc + cur);
            this.quizStat.avgDuration = Math.round(c / this.results.length);

            this.scoreRangeStat.splice(0);
            for (let i = 0; i < 10; i++) {
                this.scoreRangeStat.push({
                    label: i * 10 + '-' + (i + 1) * 10,
                    data: 0
                });
            }

            this.highestScore = 0;

            this.results.forEach(r => {
                if (r.score100 === 0) {
                    this.scoreRangeStat[0].data++;
                } else {
                    this.scoreRangeStat[Math.floor((r.score100 - 1) / 10)].data++;
                }
                if (r.score100 > this.highestScore) this.highestScore = r.score100;
            });


            const data = JSON.parse(JSON.stringify(msgData));
            if (this.topicAccuracyStatSortBy === 'displayOrder') {
                data.results.sort((a, b) => a.displayOrder - b.displayOrder);
            } else if (this.topicAccuracyStatSortBy === 'pct') {
                data.results.sort((a, b) => a.pct - b.pct);
            }
            this.topicAccuracyStat.splice(0);
            data.results.forEach(r => {
                this.topicAccuracyStat.push({
                    id: r.topicId,
                    displayOrder: r.displayOrder,
                    accuracy: r.pct,
                    accuracyString: Math.round(r.pct * 100)
                });
            });

            this.highestMemberCount = Math.max.apply(Math, this.scoreRangeStat.map(s => s.data));

            if (this.currentLayer !== 'quiz-stat') this.currentLayer = 'quiz-stat';
        },

        /**
         * Show single user's result
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/03act/03quiz/#3-3-3}
         * @param  {Object} msgData the message data
         * @return {void}         
         */
        handleShowUserResultMessage: function(msgData) {
            if (! msgData) return;
            const data = JSON.parse(JSON.stringify(msgData));
            // find the user in results collection
            const index = this.results.findIndex(r => r.user.id === data.userId);
            if (index === -1) {
                console.log('can not find user ', data.userId, 'in quiz results collection. please check your code');
                return;
            }

            data.results.sort((a, b) => a.displayOrder - b.displayOrder);

            const r = this.results[index];
            console.log('data.results', data.results);
            let results;

            results = data.results.map(r => {
                let newResult = {
                    type: r.type,
                    topicId: r.topicId,
                    userResult: r.userResult,
                    displayOrder: r.displayOrder,
                    score: r.score,

                };
                switch (r.type) {
                    case TYPE.SINGLE:
                    case TYPE.MULTI:
                        r.choices = r.choice || '';
                        newResult.choices = r.choices.split('');
                        // newResult.choicesString = newResult.choices.map(c => String.fromCharCode(+c + 65)).join(' ');
                        let choicesString = [];
                        newResult.choices.map((c, i) => {
                            if (+c == 1) {
                                choicesString.push(String.fromCharCode(+i + 65));
                            }
                        });
                        newResult.choicesString = choicesString.join('');
                        break;
                    case TYPE.TF:
                        newResult.tfAnswer = r.tfAnswer;
                        break;
                    case TYPE.FILL:
                        newResult.blanks = Array.isArray(r.blanks) && r.blanks || [];
                        // itemNo: 0, content: "2", submitItemNo: 0, result: 0}
                        let hasRight = false;
                        let hasWrong = false;
                        newResult.blanks.map(b => {
                            if (b.result == 1) {
                                hasRight = true;
                            } else {
                                hasWrong = true;
                            }
                        });
                        hasRight && hasWrong && (newResult.userResult = -2);

                        break;
                }
                return newResult;
            })

            const ur = {
                fullName: r.user.fullName,
                studentNo: r.user.studentNo,
                avatarUrl: r.user.avatarUrl,
                score: r.score,
                score100: r.score100,
                duration: r.duration,
                rank: r.rank,
                results
            };

            this.currentUser = ur;
            if (this.currentLayer != 'user-stat') this.currentLayer = 'user-stat';
        },

        /**
         * Show 1 topic
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/03act/03quiz/#3-3-2}
         * @param  {Object} msgData the message data
         * @return {void}         
         */
        handleShowTopicMessage: function (msgData) {
            this.$refs.quizBox.scrollTop = 0;
            if (! msgData) return;
            const topic = JSON.parse(JSON.stringify(msgData.topic));
            // no updated needed
            // if (this.currentTopic != null && this.currentTopic.id === topic.id) return;
            // handle pic
            if (topic.createType == 'PHOTO') {
                topic.picOption = this.parseChoiceAnswer(topic.answerVal, topic.optionCount);
            } else {
                this.setOptionsIsAnswerFlag(topic.options, topic.answerVal);
            }

            // handle math
            if (topic.latexIncluded !== 'Y' && this.judgeLatex(topic)) {
                topic.latexIncluded = 'Y';
            }

            //handle score
            if (topic.type == TYPE.FILL && topic.fill && topic.fill.blankAlternatives) {
                topic.score =  topic.score / topic.fill.blankAlternatives.length || 1;
            }

            // handle kps/analysis
            if (!topic.kps || !topic.kps.length) {
                topic.kps = [{id: -1, kp: '暂无知识点'}]
            }
            topic.analysis = topic.analysis || '暂无解析';

            this.currentTopic = topic;
            this.titlePlus = ` - 题目 ${topic.displayOrder + 1}`;
            if (this.currentLayer != 'topic') this.currentLayer = 'topic';
            Vue.nextTick(() => {
                // this.convertMML2SVG();
                // Prism.highlightAll();
                // let contentRtf = this.$refs.contentRtf;
                // let hyperlink = document.querySelectorAll('a');
                // hyperlink.forEach(h => h.href = '#');
                this.convertMML2SVG();
            });
        },

        /**
         * Initial show quiz activity, enter rank layer
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/03act/03quiz/#3-3-1}
         * @param  {Object} msgData the message data
         * @return {void}         
         */
        handleShowQuizMessage: function(msgData) {
            if (! msgData) return;
            this.resetData();
            this.serverTimestamp = msgData.serverTimestamp;
            // Copy the data from message to local variables
            const quiz = JSON.parse(JSON.stringify(msgData.quiz));
            if ( ! quiz) return;
            this.memberCount = +quiz.memberCount;

            quiz.results.forEach(r => {
                if (! r.user.studentNo) r.user.studentNo = '';
                if (! r.user.avatarUrl) r.user.avatarUrl = this.defaultAvatar;
                r.score100 = quiz.paperScore > 0 ? Math.round(r.score * 100 / quiz.paperScore) : 0;
            });

            // Initialize the data before associated with Vue data
            this.sortResults(quiz.results);
            this.setRank(quiz.results);


            ['id', 
             'title',
             'clazzCourseId', 
             'score', 
             'paperScore', 
             'status', 
             'startTime', 
             'endTime', 
             'autoEnd', 
             'autoEndTime'].forEach(p => {
                this[p] = quiz[p];
            });

            this.results.splice(0);
            quiz.results.forEach(r => {
                this.results.push(r);
            });

            this.calcTimerRequired();

            this.currentLayer = 'rank';
        },

        moveJoystick: function(msgData) {
            let direction = msgData.direction;
            let quizBox = this.$refs.quizBox;
            let quizImg = this.$refs.selectedImage;

            if (this.hintData == 'start') return;
            if (direction === 'LEFT') {
                if (this.hasImage) {
                    this.moveX += 40;
                    quizImg.style.transform = tool.getImgStyle(this.factor, this.moveX, this.moveY, this.rotate);
                };
                return;
            } else if (direction === 'RIGHT') {
                if (this.hasImage) {
                    this.moveX -= 40;
                    quizImg.style.transform = tool.getImgStyle(this.factor, this.moveX, this.moveY, this.rotate);
                };
                return;
            } else if (direction === 'UP') {
                if (!this.hasImage) quizBox.scrollTop -= 40;
                if (this.hasImage) {
                    this.moveY += 40;
                    quizImg.style.transform = tool.getImgStyle(this.factor, this.moveX, this.moveY, this.rotate);
                };

            } else if (direction === 'DOWN') {
                if (!this.hasImage) quizBox.scrollTop += 40;
                if (this.hasImage) {
                    this.moveY -= 40;
                    quizImg.style.transform = tool.getImgStyle(this.factor, this.moveX, this.moveY, this.rotate);
                };
            } else {
                return;
            }

        },

        rotateImg: function(msgData) {
            this.rotate += 90;
            let quizImg = this.$refs.selectedImage;
            if (quizImg) {
                quizImg.style.transform = tool.getImgStyle(this.factor, this.moveX, this.moveY, this.rotate);
            }
        },

        zoomTo: function(msgData) {
            this.factor = msgData.scaleFactor;
            let quizImg = this.$refs.selectedImage;
            if (quizImg) {
                quizImg.style.transform = tool.getImgStyle(this.factor, this.moveX, this.moveY, this.rotate);
            }
        },

        showFilesImage: function(msgData) {
            let loadingWidth = 100;
            let loadingHeight = 100;

            this.selectedImage = {
                relationId: msgData.id,
                src: loading,
                styleString: 'left: ' + Math.round(window.innerWidth - loadingWidth) / 2 + 'px; top: ' + Math.round(window.innerHeight - loadingHeight) / 2 + 'px; transform: scale(1.0);',
                baseFactor: 1.0
            };

            let tempImage = new Image();
            tempImage.addEventListener('load', () => {
                let factor = 1.0;

                if (tempImage.width < window.innerWidth && tempImage.height < window.innerHeight) {

                } else {
                    factor = Math.max(tempImage.width / window.innerWidth, tempImage.height / window.innerHeight);
                }
                factor = 1 / factor;

                this.selectedImage = {
                    relationId: msgData.id,
                    src: tempImage.src,
                    styleString: 'left: ' + Math.round(window.innerWidth - tempImage.width) / 2 + 'px; top: ' + Math.round(window.innerHeight - tempImage.height) / 2 + 'px; transform: scale(' + factor + ');',
                    baseFactor: factor
                };
                this.factor = factor;

            });
            tempImage.src = msgData.data.url;
        },

        showFilesAudio: function(msgData) {
            let listA = document.querySelectorAll('a');
            if (window.NodeList && !NodeList.prototype.forEach) {
                NodeList.prototype.forEach = function (callback, thisArg) {
                    thisArg = thisArg || window;
                    for (let i = 0; i < this.length; i++) {
                        callback.call(thisArg, this[i], i, this);
                    }
                };
            }
            listA.forEach((a,index) => {
                if (a.href.trim() === msgData.data.url.trim()) msgData.data.name = a.innerText;
            });
            this.hasAudio = true;
            this.quizAudioData = msgData;
        },

        resetData: function() {
            this.hasImage = false;
            this.hasAudio = false;
        },

        parseLevel(level) {
            if (!level) return '';
            let str = '';
            switch(+level) {
                case 10:
                    str = '简单'
                    break
                case 20:
                    str = '一般'
                    break
                case 30:
                    str = '困难'
                    break
            }
            return str;
        },
    },

    
};
</script>

<style scoped>
    .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .quiz-box {
        position: relative;
        overflow-x: hidden;
        overflow-y: auto;
    }


    .title-bar {
        position: fixed;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 80px;
        padding: 20px 40px 20px 40px;
        background-color: #191919;
        width: 100%;
        box-sizing: border-box;
        z-index: 9;
    }

    .title-bar .led-timer {
        flex-shrink: 0;
        flex-grow: 0;
    }

    .title-bar .title {
        flex-grow: 1;
        height: 40px;
        line-height: 40px;
        vertical-align: middle;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
        font-size: 24px;
        flex-grow: 1;
        color: #ffffff;
    }

    .title-bar .stat-info {
        flex-grow: 0;
        flex-shrink: 0;
        padding-left: 40px;
        text-align: right;
        line-height: 36px;
        vertical-align: middle;
    }

    .title-bar .stat-info .label {
        flex-grow: 1;
        font-size: 18px;
        color: #BBC2C6;
        vertical-align: middle;
        padding: 0 10px;
    }

    .title-bar .stat-info .data {
        display: inline-block;
        font-size: 30px;
        color: #53A2F2;
        vertical-align: middle;
    }

    .layer {
    }

    .content-box {
        /*overflow-x: hidden;*/
        /*overflow-y: auto;*/
        padding-top: 80px;
    }

    .hint-layer {
        position: absolute;
        top: 80px;
        left: 0;
        right: 0;
        bottom: 0;
        box-sizing: border-box;
        background-color: #252525;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .hint-layer .hint-content {
        background-image: url('../assets/image/quiz-no-result.png');
        background-size: 200px 200px;
        background-repeat: no-repeat;
        background-position: 50% top;
        padding-top: 230px;
        font-size: 24px;
        color: #ffffff;
    }

    .rank-box {
        padding: 40px;
    }


    table.rank {
        border-collapse: collapse;
        border: 0;
        table-layout: fixed;
        width: 100%;
        box-sizing: border-box;
    }

    table.rank > thead > tr {

    }

    table.rank > thead > tr > th {
        background-color: #1F1F1F;
        font-weight: normal;
        color: #BBC2C6;
        text-align: center;
        vertical-align: middle;
        font-size: 24px;
        padding: 18px 0;
        border: 0;
    }

    table.rank > thead > tr > th:first-child{
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }

    table.rank > thead > tr > th:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
    }

    table.rank > tbody > tr {
        color: #ffffff;
        font-size: 1.5rem;
        margin-top: 20px;
    }

    table.rank > tbody > tr > td {
        padding: 20px 0 0 0;
        border: 0;
    }

    table.rank > tbody > tr > td > div {
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    table.rank > tbody > tr > td:nth-child(3) > div {
        text-align: left;
    }

    table.rank > tbody > tr > td:first-child > div {
        overflow: visible;
    }

    table.rank > tbody > tr.top-rank > td:first-child > div::after {
        content: ' ';
        position: absolute;
        top: -14px;
        left: 0;
        right: 0;
        bottom: 0;
        background-size: 80px 94px;
        background-position: center top;
        background-repeat: no-repeat;
    }
    
    table.rank td div.avatar {
        overflow: hidden;
        text-align: right;
        padding-right: 15px;
        padding-top: 15px;
    }

    table.rank td div.avatar img.avatar {
        display: block;
        float: right;
        width: 42px;
        height: 42px;
        border: 4px solid #fff;
        border-radius: 50px;
    }

    /* top rank: 1 */
    table.rank > tbody > tr.top-rank.rank1 > td:first-child > div {
        background-image: linear-gradient(to right, #E2D5B7, #D1C19D);
    }
    
    table.rank > tbody > tr.top-rank.rank1 > td:nth-child(2) > div {
        background-image: linear-gradient(to right, #D1C19D, #CBBB95);
    }

    table.rank > tbody > tr.top-rank.rank1 > td:nth-child(3) > div {
        background-image: linear-gradient(to right, #CBBB95, #AA9262);
    }

    table.rank > tbody > tr.top-rank.rank1 > td:nth-child(4) > div {
        background-image: linear-gradient(to right, #AA9262, #A18754);
    }

    table.rank > tbody > tr.top-rank.rank1 > td:nth-child(5) > div {
        background-image: linear-gradient(to right, #A18754, #9E834F);
    }

    table.rank > tbody > tr.top-rank.rank1 > td:nth-child(6) > div {
        background-image: linear-gradient(to right, #9E834F, #967944);
    }


    /* top rank: 2 */
    table.rank > tbody > tr.top-rank.rank2 > td:first-child > div {
        background-image: linear-gradient(to right, #BCC5D1, #ADB7C3);
    }
    
    table.rank > tbody > tr.top-rank.rank2 > td:nth-child(2) > div {
        background-image: linear-gradient(to right, #ADB7C3, #AAB3C0);
    }

    table.rank > tbody > tr.top-rank.rank2 > td:nth-child(3) > div {
        background-image: linear-gradient(to right, #AAB3C0, #8F99A6);
    }

    table.rank > tbody > tr.top-rank.rank2 > td:nth-child(4) > div {
        background-image: linear-gradient(to right, #8F99A6, #7A8591);
    }

    table.rank > tbody > tr.top-rank.rank2 > td:nth-child(5) > div {
        background-image: linear-gradient(to right, #7A8591, #727C89);
    }

    table.rank > tbody > tr.top-rank.rank2 > td:nth-child(6) > div {
        background-image: linear-gradient(to right, #727C89, #5F6A77);
    }

    
    /* top rank: 3 */
    table.rank > tbody > tr.top-rank.rank3 > td:first-child > div {
        background-image: linear-gradient(to right, #DCAC82, #D09F74);
    }
    
    table.rank > tbody > tr.top-rank.rank3 > td:nth-child(2) > div {
        background-image: linear-gradient(to right, #D09F74, #CD9C71);
    }

    table.rank > tbody > tr.top-rank.rank3 > td:nth-child(3) > div {
        background-image: linear-gradient(to right, #CD9C71, #B58358);
    }

    table.rank > tbody > tr.top-rank.rank3 > td:nth-child(4) > div {
        background-image: linear-gradient(to right, #B58358, #A37144);
    }

    table.rank > tbody > tr.top-rank.rank3 > td:nth-child(5) > div {
        background-image: linear-gradient(to right, #A37144, #9B683C);
    }

    table.rank > tbody > tr.top-rank.rank3 > td:nth-child(6) > div {
        background-image: linear-gradient(to right, #9B683C, #8B572A);
    }


    table.rank > tbody > tr.top-rank.rank1 > td:first-child > div::after {
        background-image: url('../assets/image/quiz-rank1.png');
    }

    table.rank > tbody > tr.top-rank.rank2 > td:first-child > div::after {
        background-image: url('../assets/image/quiz-rank2.png');
    }

    table.rank > tbody > tr.top-rank.rank3 > td:first-child > div::after {
        background-image: url('../assets/image/quiz-rank3.png');
    }


    table.rank > tbody > tr > td:first-child > div {
        border-top-left-radius: 8px; 
        border-bottom-left-radius: 8px;
    }

    table.rank > tbody > tr > td:last-child > div {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
    }

    table.rank > tbody > tr > td > div {
        box-sizing: border-box;
        background-color: #646464;
        height: 80px;
        line-height: 80px;
        vertical-align: middle;
        width: 100%;
    }

    
    .topic-box,
    .total-stat-box,
    .topic-stat-box {
        padding: 40px;
    }

    .topic-box .topic-meta {
        color: #fff;
        font-size: 24px;
        text-align: left;
        display: flex;
        font-size: 24px;
        align-items: center;
    }

    .topic-box .topic-meta .topic-flag {
        width: 104px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
    }
    .SINGLE {
        background: #67A8EB;
    }
    .MULTI {
        background: #9384EE;
    }
    .TF {
        background: #40D0B5;
    }
    .FILL {
        background: #F5A43B;
    }

    .topic-box .topic-subject {
        padding-top: 40px;
        /* padding-bottom: 20px; */
    }

    .topic-box .option-box {
        padding-top: 20px;
    }

    .topic-box .option-box .option {
        margin-top: 20px;
        display: flex;
    }

    .topic-box .option-box .option .item-no {
        flex-shrink: 0;
        flex-grow: 0;
        width: 108px;
        background-color: #464646;
        color: #ffffff;
        text-align: center;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        border-right: 2px solid rgba(0, 0, 0, 0.2);
        font-size: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }


    .topic-box .option-box .option .content {
        flex-shrink: 0;
        flex-grow: 1;
        flex-basis: 100px;
        overflow-x: auto;
        background-color: #464646;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        padding: 20px 30px;
    }

    .topic-box .option-box .option.is-answer .item-no {
        background-color: #53A2F2;
    }

    .topic-box .option-box .option.is-answer .content {
        background-color: #53A2F2;
    }

    .topic-box .analysis {
        margin-top: 20px;
        display: flex;
        background: #464646;
        flex-direction: column;
        border-radius: 8px;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 36px;
        padding: 20px 40px
    }

    .topic-box .analysis .label {
        flex-grow: 0;
        flex-shrink: 0;
        padding-bottom: 20px;
        /*width: 112px;*/
        /*box-sizing: border-box;*/
    }
    .topic-box .analysis .label img {
        max-width: 100%;
    }

    .topic-box .analysis .label div {
        text-align: left;
    }

    .topic-box .analysis .content {
        flex-grow: 1;
        /* flex-basis: 100px; */
        color: #fff;
    }
    

    .total-stat-row {
        display: flex;
    }

    .total-stat-row .score-duration-box {
        padding: 47px 0;
        border-radius: 8px;
        flex-shrink: 0;
        flex-grow: 0;
        background-color: #444444;
        text-align: center;
        width: 180px;
    }

    .total-stat-row .score-duration-box .data {
        font-size: 24px;
        line-height: 100%;
        color: #ffffff;
        padding-bottom: 10px;
    }

    .total-stat-row .score-duration-box .label {
        font-size: 18px;
        line-height: 100%;
        color: #BBC2C6;
    }

    .total-stat-row .score-duration-box .sep {
        height: 2px;
        background-color: rgba(0, 0, 0, 0.3);
        margin: 40px;
    }

    .total-stat-row .score-range-box {
        border-radius: 8px;
        flex-grow: 1;
        flex-basis: 100px;
        padding: 30px;
        margin-left: 20px;
        background-color: #444444;
    }

    .total-stat-row .score-range-box .title {
        font-size: 18px;
        line-height: 100%;
        text-align: left;
        color: #BBC2C6;
        padding-bottom: 20px;
    }

    .total-stat-row .score-range-box .bar-chart {
        height: 182px;
        display: flex;
        align-items: flex-start;
    }
    
    .total-stat-row .score-range-box .bar-chart .bar-box {
        /*padding-left: 20px;*/
        /*padding-right: 30px;*/
        margin-left: auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
    }

    .total-stat-row .score-range-box .bar-chart .bar-box:first-child {
        margin-left: 0;
    }

    .total-stat-row .score-range-box .bar-chart .bar-box .label {
        flex-shrink: 0;
        flex-grow: 0;
        padding-top: 10px;
        color: #BBC2C6;
        font-size: 18px;
        line-height: 100%;
    }

    .total-stat-row .score-range-box .bar-chart .bar-box .bar {
        width: 20px;
        height: 60px;
        background-image: linear-gradient(-180deg, #81B6DB 0%, #53A2F2 100%);
        border-radius: 2px;
    }

    .total-stat-row .score-range-box .bar-chart .bar-box .data {
        flex-shrink: 0;
        flex-grow: 0;
        padding-bottom: 10px;
        color: #FFFFFF;
        font-size: 24px;
        line-height: 100%;
    }

    .total-stat-box .section-title {
        text-align: left;
        padding-top: 40px;
        font-size: 18px;
        line-height: 100%;
        color: #FFFFFF;
    }

    .total-stat-box .topic-accuracy-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-left: -24px;
    }

    .total-stat-box .topic-accuracy-box .topic-accuracy {
        flex-flow: 0;
        flex-grow: 0;
        width: 216px;
        padding: 20px 30px;
        background-color: #444;
        margin-top: 20px;
        margin-bottom: 10px;
        margin-left: 24px;
        border-radius: 4px;
    }

    .total-stat-box .topic-accuracy-box .topic-accuracy .circle-chart {
        float: left;
        width: 70px;
        height: 70px;
    }

    .total-stat-box .topic-accuracy-box .topic-accuracy .circle-chart svg {
        width: 100%;
        height: 100%;
    }

    .total-stat-box .topic-accuracy-box .topic-accuracy .info {
        float: left;
        padding-top: 10px;
        margin-left: 20px;
        font-size: 18px;
        line-height: 100%;
        color: #fff;
        text-align: left;
    }
    
    /* user stat */
    .user-stat-box {
        padding: 40px;
    }

    .user-stat-row {
        display: flex;
    }

    .user-stat-row .avatar-col {
        background-color: #444444;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 30px;
        width: 440px;
        height: 140px;
        flex-grow: 0;
        flex-shrink: 0;
        background-size: 176px 140px;
        background-repeat: no-repeat;
        background-position: right top;

        display: flex;
    }

    .user-stat-row .avatar-col.rank1 {
        background-image: url('../assets/image/quiz-user-rank1.png');
    }

    .user-stat-row .avatar-col.rank2 {
        background-image: url('../assets/image/quiz-user-rank2.png');
    }

    .user-stat-row .avatar-col.rank3 {
        background-image: url('../assets/image/quiz-user-rank3.png');
    }

    .user-stat-row .avatar-col div.avatar {
        box-sizing: border-box;
        width: 80px;
        height: 80px;
        border-radius: 40px;
        overflow: hidden;
        border: 4px solid #FFFFFF;;
    }
    
    .user-stat-row .avatar-col img.avatar {
        width: 72px;
        height: 72px;
    }

    .user-stat-row .avatar-col .info-col {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .user-stat-row .avatar-col .info-col div {
        font-size: 24px;
        line-height: 24px;
        color: #fff;
        text-align: left;
    }

    .user-stat-row .avatar-col .info-col .name,
    .user-stat-row .avatar-col .info-col .sno {
        width: 150px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .user-stat-row .avatar-col .info-col .sno {
        margin-top: 16px;
    }
    

    .user-stat-row .stat-col {
        margin-left: 20px;
        flex-grow: 1;
        background-color: #444;
        border-radius: 8px;
        display: flex;
    }

    .user-stat-row .stat-col .data-col {
        flex-shrink: 1;
        flex-grow: 1;

        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .user-stat-row .stat-col .data-col .data {
        text-align: center;
        font-size: 30px;
        line-height: 100%;
        color: #fff;
    }

    .user-stat-row .stat-col .data-col .label {
        text-align: center;
        font-size: 18px;
        line-height: 100%;
        margin-top: 20px;
        color: #BBC2C6;
    }

    .user-topic-box {
        margin-top: 10px;
        margin-left: -20px;
    }

    .user-topic-box .user-topic {
        float: left;
        width: 50%;
        margin-top: 20px;
        box-sizing: border-box;
        padding-left: 20px;
    }

    .user-topic-box .user-topic .user-topic-t {
        display: flex;
        flex-direction: row;
        padding: 15px 15px 15px 40px;
        justify-content: flex-start;
        align-items: center;
        border-radius: 4px;
        background-size: 30px 30px;
        background-repeat: no-repeat;
        background-position: 15px 50%;
    }

    .user-topic-box .user-topic .user-topic-t .choice,
    .user-topic-box .user-topic .user-topic-t .user-answer {
        color: #fff;
        font-size: 24px;
        line-height: 100%;
        flex-grow: 1;
        flex-shrink: 0;
        border-left: 2px solid rgba(0, 0, 0, 0.2);
        text-align: left;
        margin-left: 10px;
        padding-left: 10px;
    }
    .user-topic .score {
        margin-left: auto;
    }

    .user-topic-box .user-topic .user-topic-t.right {
        background-image: url('../assets/image/quiz-user-right.png');
        background-color: #53A2F2;
    }

    .user-topic-box .user-topic .user-topic-t.wrong {
        background-image: url('../assets/image/quiz-user-wrong.png');
        background-color: #F26E50;
    }

    .user-topic-box .user-topic .user-topic-t.part-right {
        background-image: url('../assets/image/quiz-user-part.png');
        background-color: #F5A43B;
    }

    .user-topic-box .user-topic .user-topic-t .score {
        color: #fff;
        font-size: 24px;
        line-height: 100%;
        flex-grow: 0;
        flex-shrink: 0;
        text-align: right;
    }

    .topic-stat-box {
        display: flex;
    }   

    .pie-chart-box {
        flex-shrink: 0;
        flex-grow: 0;
        width: 570px;
    }

    .pie-chart-box .title {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        background-color: #191919;
        padding: 23px 20px;

        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .pie-chart-box .title .label {
        font-size: 18px;
        color: #BBC2C6;
        flex-shrink: 0;
        flex-grow: 0;
    }

    .pie-chart-box .title .label:first-child {
        flex-grow: 1;
        text-align: left;
    }

    .pie-chart-box .title .label:last-child {
        text-align: right;
    }

    .pie-chart-box .title .legend {
        background-color: #53A2F2;
        border-radius: 4px;
        margin-right: 10px;
        height: 20px;
        width: 20px;
        flex-grow: 0;
        flex-shrink: 0;
    }

    .pie-chart-box .pie-chart {
        width: 530px;
        height: 426px;
        padding: 20px;
        background-color: #444;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        padding: 20px;
    }

    .topic-stat-box .topic-container {
        flex-grow: 1;
        margin-left: 30px;
        overflow-x: auto;
    }

    .topic-stat-box .topic-container .topic-box {
        padding-left: 0;
        padding-top: 0;
        padding-right: 0;
        max-width: 100%;
    }

    .topic-stat-box .topic-container .topic-box .topic-subject {
        padding-top: 20px;
    }

    .quiz-member-count {
        display: inline-block;
        font-size: 30px;
        color: #ffffff;
        vertical-align: middle;
    }

    .tf-item {
        background: #464646;
        border-radius: 8px;
        height: 70px;
        padding-left: 40px;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 40px;
        display: flex;
        align-items: center;
        margin-top: 20px;
    }
    .tf-right {
        /* margin-top: 40px; */
    }
    .tf-answer {
        font-weight: 700;
        background: #53A2F2;
    }
    /* .mceNonEditable.fill {
        border-bottom: 1px solid #0bd;
    } */
    .t-photo {
        display: flex;
        flex-direction: column;
    }
    .t-photo img {
        margin-top: 20px;
        max-width: 100%;
    }
    .user-fill {
        max-width: 70%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: pre;
    }
    .kps {
        border-radius: 8px;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 36px;
        padding: 20px 40px;
        display: flex;
        background: #464646;
        margin-top: 20px;
        flex-direction: column;
        text-align: left;
    }
    .pic-opt {
        background: #53A2F2;
        border-radius: 8px;
        padding-left: 40px;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 40px;
        font-weight: 700;
        text-align: left;
        height: 70px;
        margin-top: 20px;
        display: flex;
        align-items: center;
    }

    .fill-item {
        display: flex;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 24px;
        background: #53A2F2;
        border-radius: 8px;
        min-height: 60px;
        margin-top: 20px;
    }
    .fill-item .fill-label {
        width: 110px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #252525;
    }
    .fill-con {
        display: flex;
        align-items: center;
        padding: 0 30px;
        white-space: pre;
        overflow: hidden;
        flex: 1;
    }
    .kps .label {
        padding-bottom: 20px;
    }
    .kps .content {
        white-space: pre-wrap;
    }
    .gap {
        width: 1px;
        height: 20px;
        background-color:  #D1DDE2;
        margin-left: 20px;
        margin-right: 20px;
    }
    .fill-plus {
        font-size: 20px;
        line-height: 20px;
        display: flex;
        /* flex-direction: column; */
        text-align: left;
        padding-bottom: 10px;
        margin-top: 20px;
    }
    .fill-plus span+span {
        margin-left: 20px;
    }
    .topic-plus {
        font-size: 20px;
        margin-left: 30px;
    }
    .topic-plus span+span {
        margin-left: 20px;
    }
    .fill-no-answer {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        color: #fff;
        height: 460px;
        background-color: #444;;
    }
</style>

<style>
/* quiz content, option, analysis have html text, use this as the parent box for styling */
    .rtf {
        color: #ffffff;
        text-align: left;
        font-size: 1.5rem;
    }

    .rtf.light-gray {
        color: #BBC2C6;
    }
    
    .rtf a,
    .rtf a:link, 
    .rtf a:visited,
    .rtf a:hover,
    .rtf a:active,
    .rtf p,
    .rtf span,
    .rtf div,
    .rtf li,
    .rtf td {
        color: #ffffff;
        font-size: 1.5rem;
        line-height: 150%;
    }
    
    .rtf img {
        max-width: 100%;
    }

    .rtf img.Wirisformula {
        background-color: #ffffff;
        padding: 10px;
    }

    .rtf .media-web-icon {
        width: 27px;
        height: 16px;
        margin-right: 10px;
    }

    .rtf .mml-svg-box {
        display: inline-block;
        vertical-align: middle;
    }

    .rtf a:hover {
        text-decoration: underline;
    }

    .rtf pre {
        border-radius: 8px;
    }

    .rtf.light-gray a,
    .rtf.light-gray a:link, 
    .rtf.light-gray a:visited,
    .rtf.light-gray a:hover,
    .rtf.light-gray a:active,
    .rtf.light-gray p,
    .rtf.light-gray span,
    .rtf.light-gray div,
    .rtf.light-gray li,
    .rtf.light-gray td {
        font-size: 1.5rem;
        line-height: 150%;
        color: #BBC2C6;
    }

    .rtf.light-gray a:hover {
        text-decoration: underline;
    }
    
    #quiz-audio {
        position: fixed;
        bottom: 0;
        left: 0;
    }

    .expand-image-box {
        position: fixed;
        overflow: hidden;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
    }

    .expand-image-box img {
        position: absolute;
        transition: transform 300ms linear;
    }

    .imgAnimation {
        animation: load 1s;
        animation-timing-function: linear;
        animation-direction: reverse;
        animation-iteration-count: infinite;
    }

    @keyframes load {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(-360deg);
        }
    }

    #quiz-audio {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
        background: #252425;
    }

    .fill {
        color: #53A2F2!important;
        border-bottom: 1px solid #53A2F2;
    }
</style>